import React, { useState } from "react";
import { Functions } from "appwrite";
import { ClipLoader } from "react-spinners";
import client from "./appwriteConfig";
import "./css/LearnMusicAI.css";

const functions = new Functions(client);

const AI_UPLOAD_FUNCTION_ID = process.env.REACT_APP_GROQ_AI_FUNCTION_ID;

function parseExecutionResponse(execution) {
  const raw =
    execution.responseBody || execution.response || execution.stdout || "";

  try {
    return JSON.parse(raw);
  } catch {
    return {
      success: false,
      detail: raw || "Function did not return JSON.",
    };
  }
}

function LearnMusicAI() {
  const [question, setQuestion] = useState("");
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      text: "Topics related to EDM, mixing, mastering, FL Studio, sound design, vocal, bass, drums, or music production questions. I’ll answer from the uploaded music PDF knowledge base.",
      sources: [],
    },
  ]);
  const [loading, setLoading] = useState(false);

  const askMusicAI = async () => {
    const cleanQuestion = question.trim();

    if (!cleanQuestion || loading) return;

    setMessages((prev) => [
      ...prev,
      {
        role: "user",
        text: cleanQuestion,
        sources: [],
      },
    ]);

    setQuestion("");
    setLoading(true);

    try {
      if (!AI_UPLOAD_FUNCTION_ID) {
        throw new Error("Missing REACT_APP_AI_UPLOAD_FUNCTION_ID in .env");
      }

      const execution = await functions.createExecution(
        AI_UPLOAD_FUNCTION_ID,
        JSON.stringify({
          question: cleanQuestion,
        }),
        false,
        "/ai/learn-music/chat",
        "POST",
        {
          "content-type": "application/json",
        },
      );

      const data = parseExecutionResponse(execution);

      if (!data.success) {
        throw new Error(data.detail || data.error || "Learn Music AI failed.");
      }

      setMessages((prev) => [
        ...prev,
        {
          role: "assistant",
          text: data.answer,
          sources: data.sources || [],
        },
      ]);
    } catch (error) {
      console.error("Learn Music AI error:", error);

      setMessages((prev) => [
        ...prev,
        {
          role: "assistant",
          text: error.message || "Learn Music AI failed.",
          sources: [],
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      askMusicAI();
    }
  };

  return (
    <section className="learn-music-ai-box">
      <div className="learn-music-ai-header">
        <div>
          <h3>Ask Me Anything ...</h3>
        </div>

        <span className={loading ? "lm-ai-status live" : "lm-ai-status"}>
          {loading ? "Searching..." : "Music RAG"}
        </span>
      </div>

      <div className="lm-ai-chat-window">
        {messages.map((message, index) => (
          <div
            key={index}
            className={
              message.role === "user"
                ? "lm-ai-message user"
                : "lm-ai-message assistant"
            }
          >
            <div className="lm-ai-role">
              {message.role === "user" ? "You" : "Hxabyte AI"}
            </div>

            <div className="lm-ai-text">{message.text}</div>
            {/* 
            {message.sources?.length > 0 && (
              <div className="lm-ai-sources">
                <strong>References used:</strong>

                {message.sources.map((source, srcIndex) => (
                  <div key={srcIndex}>
                    {srcIndex + 1}. {source.sourceTitle || "Music PDF"}
                    {source.topic ? ` — ${source.topic}` : ""}
                    {source.chunkIndex ? ` — chunk ${source.chunkIndex}` : ""}
                  </div>
                ))}
              </div>
            )} */}
          </div>
        ))}

        {loading && (
          <div className="lm-ai-loading">
            <ClipLoader size={14} color="#fff" />
            <span>Searching your music PDF chunks...</span>
          </div>
        )}
      </div>

      <div className="lm-ai-input-row">
        <textarea
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Example: How do I make EDM kick and bass sit together?"
          rows={2}
        />

        <button onClick={askMusicAI} disabled={loading || !question.trim()}>
          {loading ? "Asking..." : "Ask"}
        </button>
      </div>
    </section>
  );
}

export default LearnMusicAI;
